import ModalDefault from "../../ModalDefault";
import { comum } from "../../../styles/Themes/light";
import { IconClose, IconEasyJurLegalOps } from "../../icons";
import { ButtonCloseModal, ModalForm, ModalHeader, ModalTitle, ModalBoard, IconModal, ModalContent } from "./styles";
import InputDefault from "../../form/InputDefault";
import ButtonIcon from "../../form/ButtonIcon";
import { IconListProps } from "../../icons";
import { useState } from "react";
import toast, { Toaster } from 'react-hot-toast';
import api from "../../../services/api";

interface ModalCriaEscritorioSolicitanteProps {
    openModalNewApplicant: boolean,
    setOpenModalNewApplicant: (openModalNewApplicant: boolean) => void,
    onSuccess?: () => void
}

export default function ModalCriaEscritorioSolicitante({ openModalNewApplicant, setOpenModalNewApplicant, onSuccess }: ModalCriaEscritorioSolicitanteProps) {
    const [ nome, setNome ] = useState<string>('');
    const [ email, setEmail ] = useState<string>('');
    const [ code, setCode ] = useState<string>('');

    function validaDadosCriacaoEscritorio() {
        if (nome === '' || email === '') {
            toast.error('Preencha todos os campos obrigatórios');
            return false;
        }
        if (nome.length > 127) {
            toast.error('O nome do escritório deve ter no máximo 127 caracteres');
            return false;
        }
        if (email.length > 127) {
            toast.error('O email do administrador deve ter no máximo 127 caracteres');
            return false;
        }
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(email)) {
            toast.error('Por favor insira um email válido');
            return false;
        }
        return true;
    }

    async function enviaRequisicaoCriacaoEscritorio(data: any): Promise<any> {
        try {
            const response = await api.post('/escritorio', data);
            return response.data

        } catch (error: any) {
            return error.response.data
        }
    }

    async function handleSendInvite() {

        const validaStatus =validaDadosCriacaoEscritorio();
        if (!validaStatus) return;

        const data = {
            nome,
            email,
            code
        }

        const result = await enviaRequisicaoCriacaoEscritorio(data);

        if(result.status === 'success') {
            toast.success('Convite enviado com sucesso');
            setOpenModalNewApplicant(false);
            // Limpar o formulário
            setNome('');
            setEmail('');
            setCode('');
            // Chamar callback de sucesso para atualizar a lista
            if (onSuccess) {
                onSuccess();
            }
        } else {
            toast.error('Erro ao enviar convite: ' + result.message);
        }
            

    }

    return (
            <ModalDefault
                id={'overlayModal'}
                onClose={() => setOpenModalNewApplicant(false)}
                openModal={ openModalNewApplicant }
                width="35%"
            >
                <ModalContent>
                    <ModalHeader>
                        <IconModal>
                            <IconEasyJurLegalOps />
                        </IconModal>
                        <ButtonCloseModal onClick={() => setOpenModalNewApplicant(false)}>
                            <IconClose color={comum.colors.interfaceGray300}/>
                        </ButtonCloseModal>
                    </ModalHeader>

                    <ModalTitle>                    
                        <h1>Convidar Novo Solicitante</h1>
                        <p>Envie um convite para que o administrador do escritório possa criar sua conta na plataforma.</p>
                    </ModalTitle>
                    
                    <ModalForm>
                        <p>Nome do Escritório <span>*</span></p>
                        <InputDefault
                            placeholder="Nome do Escritório de Advocacia"
                            value={nome}
                            onChangeText={(e: any) => setNome(e)}
                            className="input-full"
                        />

                        <p>Email do Administrador <span>*</span></p>
                        <InputDefault
                            placeholder="admin@escritorio.com"
                            value={email}
                            onChangeText={(e: any) => setEmail(e)}
                            className="input-full"
                        />

                        <p>Código Interno</p>
                        <InputDefault
                            placeholder="0"
                            type="number"
                            value={code}
                            onChangeText={(e: any) => setCode(e)}
                            className="input-full"
                        />   
                    </ModalForm>


                    <ModalBoard>                    
                        <p>Como funciona:</p>
                        <ul>
                            <li>O administrador receberá um email de convite</li>
                            <li>Ele poderá criar a conta do escritório</li>
                            <li>Após o cadastro, poderá acessar a plataforma</li>
                        </ul>
                    </ModalBoard>
                    
                    <ButtonIcon
                        Icon={<IconListProps />}
                        children={'Enviar Convite'}
                        styles="save"
                        onClick={handleSendInvite}
                    />
                </ModalContent>
            </ModalDefault>
    );
}